import { SvgIcon, SvgIconProps } from "@mui/material";

export function ClockIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M8 13.333A5.333 5.333 0 1 0 8 2.667a5.333 5.333 0 0 0 0 10.666m0-12a6.667 6.667 0 1 1 0 13.334c-3.687 0-6.667-3-6.667-6.667A6.667 6.667 0 0 1 8 1.333m.333 3.334v3.5l3 1.78-.5.82-3.5-2.1v-4h1z" />
    </SvgIcon>
  );
}
